export const SALT_LENGTH = 16;
export const KEY_SIZE = 32;
export const ITERATIONS = 10000;
//# sourceMappingURL=constants.js.map